export function Project(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2 5.75037C12.2595 5.28744 13 4.23019 13 3C13 1.34315 11.6569 0 10 0C8.34315 0 7 1.34315 7 3C7 4.23019 7.74046 5.28744 8.8 5.75037V8.8H6C3.6804 8.8 1.8 10.6804 1.8 13V14.2496C0.740457 14.7126 0 15.7698 0 17C0 18.6569 1.34315 20 3 20C4.65685 20 6 18.6569 6 17C6 15.7698 5.25954 14.7126 4.2 14.2496V13C4.2 12.0059 5.00589 11.2 6 11.2H8.8V14.2496C7.74046 14.7126 7 15.7698 7 17C7 18.6569 8.34315 20 10 20C11.6569 20 13 18.6569 13 17C13 15.7698 12.2595 14.7126 11.2 14.2496V11.2H14C14.9941 11.2 15.8 12.0059 15.8 13V14.2496C14.7405 14.7126 14 15.7698 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.7698 19.2595 14.7126 18.2 14.2496V13C18.2 10.6804 16.3196 8.8 14 8.8H11.2V5.75037Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
